import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";
import { take } from "rxjs/operators";
import { IEnvironmentConfig } from "src/app/shared/interfaces/IEnvironmentConfig";
import { IUser } from "./interfaces/IUser";

/** Credentials to be used when interacting with the OrthoFi Gatekeeper API */
const httpOptions = { withCredentials: true };

@Injectable({
  providedIn: "root",
})
export class UserService {
  private _userBehaviorSubject = new ReplaySubject<IUser>(null);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public userObservable = this._userBehaviorSubject.asObservable();

  constructor(
    @Inject("ENV") private _env: IEnvironmentConfig,
    private _http: HttpClient
  ) {
    this._getAuthenticatedUser()
      .pipe(take(1))
      .subscribe((user) => {
        this._userBehaviorSubject.next(user);
      });
  }

  private _getAuthenticatedUser(): Observable<IUser> {
    const url = `${this._env.gatekeeperUrl}/api/v1/configuration/clientconfig/2`;
    return this._http.get<IUser>(url, httpOptions);
  }
}
